export enum AppType {
    Web = "Web",
    Application = "Application"
}